<template>
  <el-sub-menu
    v-if="hasChildren && item.hidden"
    :index="item.name"
    :class="useUserStore().locale == 'zh-cn' ? 'zntxt' : 'nozntxt'"
  >
    <!-- {{ item }} -->
    <template #title>
      <el-badge
        :value="
          item.path == '/customer'
            ? chatListStore.unReadNumber > 0
              ? chatListStore.unReadNumber
              : ''
            : ''
        "
        class="badge-style"
        type="danger"
      >
      </el-badge>
      <el-popover :width="200" trigger="hover" :visible="false">
        <template #reference>
          <div
            :class="{
              'red-dot':
                (hasSuperviseInfo && item.name == 'check_manage') || (item.path == '/workorder' ? isShowDot : false) ||
                (hasOrderInfo && item.name == 'workorder_manage')
            }"
            style="
              width: 24px;
              height: 24px;
              font-size: 24px;
              color: #c2c6ce;
              margin-right: 0.55rem;
            "
            v-if="!item.isActive"
            @mouseenter="showTooltip(item.name)"
            @mouseleave="hideTooltip"
          >
            <template v-for="(icon, name) in options">
              <img
                v-if="item.icon == name"
                :src="icon"
                alt=""
                class="icon default-icon"
                :height="!isCollapse ? 30 : 18"
                :width="!isCollapse ? 30 : 18"
              />
            </template>
            <div v-if="isCollapse && useUserStore().locale == 'zh-cn'" class="collapse-title">
              {{ $t(item.name) ? $t(item.name).substring(0, 2) : '' }}
            </div>
          </div>
          <div
            :class="{
              'red-dot':
                (hasSuperviseInfo && item.name == 'check_manage') || (item.path == '/workorder' ? isShowDot : false) ||
                (hasOrderInfo && item.name == 'workorder_manage')
            }"
            style="
              font-size: 24px;
              width: 24px;
              height: 24px;
              color: #c2c6ce;
              margin-right: 0.55rem;
            "
            v-else-if="item.isActive"
            @mouseenter="showTooltip(item.name)"
            @mouseleave="hideTooltip"
          >
            <template v-for="(icon, name) in options">
              <img
                v-if="item.icon == name"
                :src="icon"
                alt=""
                class="icon active-icon"
                :height="!isCollapse ? 30 : 18"
                :width="!isCollapse ? 30 : 18"
              />
            </template>
          </div>
        </template>
      </el-popover>
      <span class="submenuname"> {{ $t(item.name) }}</span>
    </template>
    <MenuItem
      v-for="(child, index) in item.children"
      :key="child.path"
      :item="child"
      :index="index"
      isChildren="true"
      :activeMenu="activeMenu"
    />
  </el-sub-menu>
  <el-menu-item
    v-else
    :index="item.path"
    v-if="item.hidden"
    class="left-chat-menu"
    :class="useUserStore().locale == 'zh-cn' ? 'zntxt' : 'nozntxt'"
  >
    <el-badge
      :value="
        item.path == '/customer'
          ? chatListStore.unReadNumber > 0
            ? chatListStore.unReadNumber
            : ''
          : ''
      "
      class="badge-style"
      type="danger"
    >
    </el-badge>
    <!-- <el-badge
      v-if="item.path == '/workorder'"
      is-dot
      value="&nbsp;"
      class="badge-style2"
      type="danger"
    >
    </el-badge> -->
    <el-popover :width="200" trigger="hover" :visible="false">
      <!-- :visible="item.name == tooltip && isCollapse && !isTooltipVisible" -->
      <template #reference>
        <div
          :class="{
            'red-dot':
              (hasSuperviseInfo && item.name == 'check_manage') || (item.path == '/workorder' ? isShowDot : false) ||
              (hasOrderInfo && item.name == 'workorder_manage'),
            zntxt: useUserStore().locale == 'zh-cn'
          }"
          style="width: 24px; height: 24px; font-size: 24px; color: #c2c6ce; margin-right: 0.55rem"
          v-if="activeMenu != item.path"
          @mouseenter="showTooltip(item.name)"
          @mouseleave="hideTooltip"
        >
          <template v-for="(icon, name) in options">
            <img
              v-if="item.icon == name"
              :src="icon"
              alt=""
              class="icon default-icon"
              :height="!isCollapse ? 30 : 18"
              :width="!isCollapse ? 30 : 18"
            />
          </template>

          <div v-if="isCollapse && useUserStore().locale == 'zh-cn'" class="collapse-title">
            {{ $t(item.name) ? $t(item.name).substring(0, 2) : '' }}
          </div>
        </div>
        <!--   v-else-if="item.isActive" -->
        <div
          :class="{
            'red-dot':
              (hasSuperviseInfo && item.name == 'check_manage') ||
              (hasOrderInfo && item.name == 'workorder_manage')
          }"
          style="font-size: 24px; width: 24px; height: 24px; color: #c2c6ce; margin-right: 0.55rem"
          v-else-if="activeMenu == item.path"
          @mouseenter="showTooltip(item.name)"
          @mouseleave="hideTooltip"
        >
          <template v-for="(icon, name) in options">
            <img
              v-if="item.icon == name"
              :src="icon"
              alt=""
              class="icon active-icon"
              :height="!isCollapse ? 30 : 18"
              :width="!isCollapse ? 30 : 18"
            />
          </template>
          <div v-if="isCollapse && useUserStore().locale == 'zh-cn'" class="collapse-title">
            {{ $t(item.name) ? $t(item.name).substring(0, 2) : '' }}
          </div>
        </div>
      </template>
    </el-popover>
    <template #title>
      <!-- && !isTooltipVisible -->
      <span
        v-if="!isChildren"
        :title="$t(item.name)"
        :class="isCollapse ? 'tipstyle' : 'menuname tipstyle2'"
      >
        {{ $t(item.name) }}</span
      >
      <span v-else class="menuname childmenuname" :title="$t(item.name)">{{ $t(item.name) }}</span>
    </template>
  </el-menu-item>
</template>

<script setup>
import { useSliderStore, useChatListStore, useUserStore, useWebSocketStore } from '@/stores'
// const webSocketStore = useWebSocketStore()
// const sliderStore = useSliderStore()
const chatListStore = useChatListStore()
import { defineProps, computed, ref } from 'vue'
import MenuItem from './index.vue'
import iconList from '@/assets/svgicon/index.js'
import { number } from 'echarts'
const options = ref(iconList)
const props = defineProps({
  item: {
    type: Object,
    required: true
  },
  isCollapse: {
    type: Boolean,
    required: false
  },
  activeMenu: {
    type: String,
    required: false,
    default: '1'
  },
  index: {
    type: number,
    required: false,
    default: '1'
  },
  tooltip: {
    type: String,
    required: false
  },
  hasSuperviseInfo: {
    type: Boolean,
    required: false
  },
  hasOrderInfo: {
    type: Boolean,
    required: false
  },
  isChildren: {
    type: Boolean,
    required: false
  },
  isTooltipVisible: {
    type: Boolean,
    required: false
  },
  isShowDot: {
    type: Boolean,
    required: false
  }
})
const showTooltip = (name) => {
  if (props.tooltip !== name) {
    props.tooltip = name
    props.isTooltipVisible = true
  }
}
const showChildTooltip = (item) => {
  console.log(item)
}
const hideTooltip = () => {
  props.tooltip = ''
  props.isTooltipVisible = false
}
const hasChildren = computed(() => {
  return props.item?.children && props.item?.children.length > 0
  // return false
})

</script>
<style scoped lang="scss">
.zntxt ::v-deep .el-tooltip__trigger {
  padding-bottom: 16px !important;
}
.nozntxt ::v-deep .el-tooltip__trigger {
  height: 40px;
}

::v-deep .el-tooltip__trigger {
  margin-right: 0 !important;
  position: relative;
  // height: 40px;
}
.collapse-title {
  font-size: 12px;
  color: #fff;
  position: absolute;
  top: 7px;
  text-align: center;
  display: inline-block;
  left: -2px;
  width: 100%;
}
.tipstyle {
  white-space: nowrap;
  margin-left: 0 !important;
  text-overflow: ellipsis;
  overflow: hidden;
}
.tipstyle2 {
  white-space: nowrap;
  margin-left: 0.55rem !important;
}
.menuname {
  margin-left: 0.55rem;
  text-overflow: ellipsis;
  overflow: hidden;
}
.childmenuname {
  margin-left: 0.55rem;
  text-overflow: ellipsis;
  overflow: hidden;
}

.submenuname {
  display: inline-block;
  left: 3.2rem;
  position: absolute;
}
.default-icon {
  filter: drop-shadow(#409eff 150px 0);
  transform: translateX(-150px);
}
.active-icon {
  filter: drop-shadow(#ffffff 150px 0);
  transform: translateX(-150px);
}
.red-dot {
  color: red;
  position: relative;
}
.red-dot::before {
  width: 8px;
  height: 8px;
  background-color: red;
  content: '';
  display: inline-block;
  border-radius: 50%;
  position: absolute;
  right: -4px;
  top: 0;
}
.left-chat {
  display: flex;
  flex-direction: column;
  // align-items: center;
  background: #334c8d;
  box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.08);
  // width: 100%;
  height: 100vh;
  padding-top: 1.25rem;
  // opacity: 0.9;
  position: relative;
  z-index: 1;
  // min-width: 4rem;

  .lc-img {
    width: 2.5rem;
    height: 2.5rem;
    cursor: pointer;
  }
  .toggleBtn {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  //这里设置展开
  // .el-menu-vertical-demo:not(.el-menu--collapse) {
  //   min-width: 10rem;
  //   min-height: 50vh;
  //   // overflow-y: auto;
  //   padding-bottom: 30px;
  // }
  // .el-menu-vertical-demo::-webkit-scrollbar {
  //   display: none; /* 隐藏滚动条 */
  // }
  .left-chat-avatar {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 6.5rem;
    margin-bottom: 0.5rem;
  }
  .left-chat-menu {
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    position: relative;

    .badge-style {
      position: absolute;
      left: 1.975rem;
      bottom: 1.6125rem;
      z-index: 99;
    }
    .badge-style2 {
      position: absolute;
      left: 1.975rem;
      bottom: 2.15rem;
      z-index: 99;
    }
  }

  .left-chat-menu:hover {
    background-color: #2a354c;
  }

  .menu-icon {
    font-size: 2.25rem;
  }
  .left-chat-menu:hover .span-text {
    color: #fff;
  }
  .span-text {
    font-size: 14px;
    font-family: Source Han Sans CN-Normal, Source Han Sans CN;
    line-height: 22px;
    margin-left: 5px;
  }
  .bottom-icon {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 8vh;
    display: flex;
    // flex-direction: ;
    padding: 0 var(--el-menu-base-level-padding);
    justify-content: center;
    align-items: center;
    .setting-box {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      width: 100%;
      span {
        color: #78c6ff;
        margin-left: 0.55rem;
      }
    }
  }
  .bottom-icon:hover {
    background-color: #2a354c;
  }
  .bottom-icon:hover #setting-two {
  }
  .user-nick-name {
    color: #f1f5ff;
    font-weight: bold;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
